<template>
  <v-alert
    v-if="shouldShow"
    :color="type"
    :icon="getIcon(type)"
    dismissible
    v-model="alert"
    @input="closeButton"
    transition="scale-transition"
  >
    <pre v-html="message"></pre>
  </v-alert>
</template>

<style lang="scss" scoped>
#jns {
  .v-alert {
    position: fixed;
    width: auto;
    z-index: 20;
    right: 30px;
    border-radius: 4px;
    top: 30px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    font-weight: bold;
    max-width: 180vh;

    .success {
      background-color: #7ed321 !important;
      color: white;
    }
  }

  pre {
    white-space: pre-line !important;
  }
}
</style>

<script lang="js">
export default {
  name: "FormAlert",
  data: () => ({
    alert: true,
    fadeAwayInterval: false,
    timeInterval: 60 * 1000,
  }),
  computed: {
    shouldShow() {
      return this.message;
    },
  },

  props: {
    source: String,
    message: String,
    type: String,
  },
  
  updated() {
    if (this.shouldShow) {
      this.fadeAwayInterval = setTimeout(() => {
        this.closeButton();
      }, this.timeInterval);
    }
  },
  destroyed() {},
  methods: {
    getIcon(type) {
      switch (type) {
        case "success":
          return "check";
          break;

        case "error":
          return "warning";
          break;
      }
    },
    closeButton() {
      let t = this;
      setTimeout(() => {
        clearInterval(this.fadeAwayInterval);
        t.$emit("close");
        t.alert = true;
      }, 500);
    },
  },
  watch: {
    alert: (val, oldVal) => {},
  },
};
</script>



// WEBPACK FOOTER //
// ./src/components/FormAlert.vue